import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Navbar.css';

// FIREBASE
import { auth, db } from '../firebase';
import { doc, onSnapshot, getDoc } from 'firebase/firestore';

// FUNCTIONS
import { unregisterAllListeners } from '../components/appComponents/ListenerManager';

// IMPORT UI
import PlanPurchasePage from '../myPlans/PlanPurchasePage';

// IMAGES
import bumpups_logo from '../assets/images/default/bumpups-logo-final.png';
import crown_plan_icon from '../assets/images/icons/crown-plan-icon.png';
import logout_icon from '../assets/images/icons/logout-icon.png';
import placeholder_profile from '../assets/images/profile/placeholder-profile.jpg';
import setting_icon from '../assets/images/icons/setting-icon.png';

function Navbar({ isSidebarOpen, toggleSidebar }) {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [profileImage, setProfileImage] = useState();
  const [showPlanPopUp, setShowPlanPopUp] = useState(false);

  const navigate = useNavigate();
  const user = auth.currentUser;

  const handleLogout = async () => {
    try {
      unregisterAllListeners();
      await auth.signOut();
      navigate('/');
    } catch (error) {
      console.error(error);
    }
  };

  // click‑outside for profile menu
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showProfileMenu &&
        !e.target.closest('.profile-dropdown') &&
        !e.target.closest('.profile-icon')
      ) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showProfileMenu]);

  // window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Profile listener
  useEffect(() => {
    if (!user) return;

    const profileDocRef = doc(db, 'users', user.uid, 'userSettings', 'profile');

    const unsubscribeProfile = onSnapshot(profileDocRef, (snap) => {
      if (snap.exists()) {
        const url = snap.data().profileImage || '';
        setProfileImage(url);
        sessionStorage.setItem(`profileImage_${user.uid}`, url);
      }
    });

    // initial fetch
    getDoc(profileDocRef).then((snap) => {
      if (snap.exists()) {
        const url = snap.data().profileImage || '';
        setProfileImage(url);
        sessionStorage.setItem(`profileImage_${user.uid}`, url);
      }
    });

    return () => unsubscribeProfile();
  }, [user]);

  return (
    <nav className="navbar">
      <div className="brand-and-toggle-container">
        <button
          onClick={toggleSidebar}
          className="sidebar-toggle"
          title={isSidebarOpen ? 'Close Sidebar' : 'Open Sidebar'}
        >
          {isSidebarOpen ? '✖' : '☰'}
        </button>
        <Link to="/dashboard" className="navbar-brand">
          <img src={bumpups_logo} alt="Bumpups Logo" className="navbar-logo" />
        </Link>
      </div>

      <div className="navbar-links">
        {windowWidth > 1280 && (
          <button
            className="add-credits-button"
            onClick={() => setShowPlanPopUp(true)}
          >
            View Plans
          </button>
        )}

        {showPlanPopUp && (
          <PlanPurchasePage
            isOpen={showPlanPopUp}
            onClose={() => setShowPlanPopUp(false)}
          />
        )}

        <img
          src={profileImage || placeholder_profile}
          alt="Profile"
          className="profile-icon"
          onClick={() => setShowProfileMenu((prev) => !prev)}
        />

        {showProfileMenu && (
          <div className="profile-dropdown active">
            <div
              className="nav-button"
              style={{ textAlign: 'left' }}
              onClick={() => setShowProfileMenu(false)}
            >
              <Link to="/settings/plan" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={crown_plan_icon} alt="Subscription Icon" className="iconmenu" />
                My plan
              </Link>
            </div>
            <div
              className="nav-button"
              style={{ textAlign: 'left' }}
              onClick={() => setShowProfileMenu(false)}
            >
              <Link to="/settings" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={setting_icon} alt="Settings Icon" className="iconmenu" />
                Settings
              </Link>
            </div>
            <div className="mainnav-divider" />
            <div
              className="nav-button"
              style={{ textAlign: 'left' }}
              onClick={() => {
                handleLogout();
                setShowProfileMenu(false);
              }}
            >
              <span style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={logout_icon} alt="Logout Icon" className="iconmenu" />
                Log out
              </span>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
